<ng-container *ngIf="isLoginShowing">
    <section>
        <form id="logInForm" [formGroup]="logInForm" (ngSubmit)="logInSubmit()">
            <h2 style="color: var(--primary)">Log In</h2>
            <mat-form-field>
                <mat-label>Email</mat-label>
                <input class="form-control" type="email" matInput formControlName="email" appearance="fill" />
                <mat-error>Email is required</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Password</mat-label>
                <input class="form-control" [type]="viewPassword ? 'text' : 'password'" matInput formControlName="password" />
                <mat-icon *ngIf="!viewPassword" matSuffix (click)="passwordVisible()" class="my-icon">visibility</mat-icon>
                <mat-icon *ngIf="viewPassword" matSuffix (click)="passwordVisible()" class="my-icon">visibility_off</mat-icon>
                <mat-error>Password is required</mat-error>
            </mat-form-field>
            <div>
                <button class="mt-4" mat-flat-button type="submit">Log In</button>
            </div>
            <div class="mt-4 mb-5 links">
                <a style="color: var(--tenant-header)" routerLink="/login/reset-password">Reset Password</a>

                <a *ngIf="requestAccessJacketId" style="color: var(--tenant-header)" [routerLink]="'/login/request-access/' + requestAccessJacketId"
                    >Request Access</a
                >
            </div>
        </form>
    </section>
</ng-container>
<ng-container *ngIf="isVerifyShowing">
    <enter-verification (verify$)="verifyChange($event)" [phone]="phone"></enter-verification>
</ng-container>

<form>
    <div class="mb-1 links">
        <a class="test-network-button" style="color: var(--tenant-header)" (click)="testNetwork()">Check Network</a>
    </div>
</form>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>
